module.exports = __webpack_public_path__ + "pc/img/about_history.f40947c7.png";